export const GET_EMAIL_TEMPLATES = gql`
  query GET_EMAIL_TEMPLATES(
    $pageInfo: PageInfoInput
    $orderBy: OrderByInput
    $search: String
  ) {
    emailTemplates(pageInfo: $pageInfo, orderBy: $orderBy, search: $search) {
      totalCount
      pageInfo {
        offset
        limit
      }
      items {
        emailTemplateId
        title
        subject
        body
        attachments {
          emailAttachmentId
          fileName
          fileType
          path
          uploadUrl
        }
        createdAt
        updatedAt
        createdBy {
          employeeId
          firstName
          lastName
        }
      }
    }
  }
`

export const RESOLVE_EMAIL_TEMPLATE = gql`
  query RESOLVE_EMAIL_TEMPLATE(
    $emailTemplateId: String!
    $applicantId: String!
  ) {
    resolveEmailTemplate(
      emailTemplateId: $emailTemplateId
      applicantId: $applicantId
    ) {
      subject
      body
      attachments {
        emailAttachmentId
        fileName
        fileType
        path
        uploadUrl
      }
    }
  }
`

export const EDIT_EMAIL_TEMPLATE = gql`
  mutation EDIT_EMAIL_TEMPLATE(
    $emailTemplateId: String!
    $input: UpdateEmailTemplateInput!
  ) {
    updateEmailTemplate(emailTemplateId: $emailTemplateId, input: $input) {
      emailTemplateId
      attachments {
        emailAttachmentId
        fileName
        fileType
        path
        createdAt
        uploadUrl
        updatedAt
      }
    }
  }
`

export const CREATE_EMAIL_TEMPLATE = gql`
  mutation CREATE_EMAIL_TEMPLATE($input: CreateEmailTemplateInput!) {
    createEmailTemplate(input: $input) {
      emailTemplateId
      attachments {
        emailAttachmentId
        fileName
        fileType
        path
        createdAt
        uploadUrl
        updatedAt
      }
    }
  }
`

export const DELETE_EMAIL_TEMPLATE = gql`
  mutation DELETE_EMAIL_TEMPLATE($emailTemplateId: String!) {
    deleteEmailTemplate(emailTemplateId: $emailTemplateId) {
      emailTemplateId
    }
  }
`
